import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "32",
  height: "32",
  fill: "currentColor",
  viewBox: "0 0 32 32"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M8.312 5.92a1.33 1.33 0 0 1 1.105-.586h13.166c.443 0 .857.22 1.105.587l2.979 4.41v.336a2.667 2.667 0 0 1-5.334.003v-.741a1.333 1.333 0 0 0-2.666 0v.738a2.667 2.667 0 1 1-5.334 0v-.738A1.335 1.335 0 0 0 12 8.596c-.736 0-1.333.597-1.333 1.333v.738a2.667 2.667 0 1 1-5.334 0v-.336zm20.793 3.256-.003.002c.146.214.231.473.231.751v.738a5.33 5.33 0 0 1-2.666 4.62v4.687q.143.242.235.516l1.778 5.334a2.667 2.667 0 0 1-2.53 3.51H5.85a2.667 2.667 0 0 1-2.53-3.51l1.778-5.334q.091-.274.235-.515v-4.688a5.33 5.33 0 0 1-2.666-4.62v-.738c0-.278.085-.537.231-.75l-.003-.003 3.207-4.748a4 4 0 0 1 3.315-1.761h13.166a4 4 0 0 1 3.315 1.761zM20 14.195A5.32 5.32 0 0 0 24 16v2.667H8V16a5.32 5.32 0 0 0 4-1.805A5.32 5.32 0 0 0 16 16a5.32 5.32 0 0 0 4-1.805M5.85 26.667l1.778-5.333h16.744l1.778 5.333zm15.483-1.333a1.333 1.333 0 0 0 0-2.667H20a1.333 1.333 0 1 0 0 2.667z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }